// src/components/Chat/ChatInput/ChatInput.jsx

import React, { useState, useRef, useEffect } from 'react';
import { Send } from 'lucide-react';
import Toast from '../../Toast/Toast';
import './ChatInput.scss';

const ChatInput = ({ conversationId, userId, socket, onMessageSent }) => {
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const textareaRef = useRef(null);
  const [toast, setToast] = useState({ message: "", type: "success" });

  const showToast = (message, type = "success") => {
    setToast({ message, type });
  };

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${Math.min(textareaRef.current.scrollHeight, 120)}px`;
    }
  }, [message]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!message.trim() || loading) return;

    if (!socket) {
      showToast('Sem conexão com o chat. Tente recarregar a página.', 'error');
      return;
    }

    setLoading(true);
    const text = message.trim();

    // O ChatHub não rejeita a chamada em caso de erro — ele manda um
    // evento "error" separado. Escuta pontualmente só durante esse envio.
    const handleHubError = (errorMessage) => {
      showToast(errorMessage || 'Erro ao enviar mensagem. Tente novamente.', 'error');
    };

    socket.on('error', handleHubError);

    try {
      await socket.invoke('SendMessage', {
        conversationId,
        message: text
      });

      setMessage('');
      onMessageSent?.();
    } catch (error) {
      // Só cai aqui em falha de conexão de verdade (socket caiu, timeout, etc.)
      showToast('Erro ao enviar mensagem. Verifique sua conexão.', 'error');
    } finally {
      socket.off('error', handleHubError);
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  return (
    <div className="chat-input-container">
      <form className="chat-input" onSubmit={handleSubmit}>
        <textarea
          ref={textareaRef}
          className="chat-input__field"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Digite sua mensagem..."
          rows={1}
          disabled={loading}
        />

        <button
          type="submit"
          className={`chat-input__send-btn ${!message.trim() || loading ? 'chat-input__send-btn--disabled' : ''}`}
          disabled={!message.trim() || loading}
        >
          {loading ? (
            <div className="chat-input__spinner" />
          ) : (
            <Send size={18} />
          )}
        </button>
      </form>

      <Toast
        message={toast.message}
        type={toast.type}
        onClose={() => setToast({ message: "", type: "success" })}
      />
    </div>
  );
};

export default ChatInput;